import { urls } from "redux-server-connection";

// import config from "../config";

//let hostname = "";
//if (typeof navigator !== "undefined" && navigator.product === "ReactNative") {
//  // hostname = `${process.env.API_PROTOCOL}://${process.env.API_HOST}`;
//  hostname = config.api.baseUrl;
//}

// interface urlOpts {
//   name: string;
//   singleActions: Array<string | { name: string, action: string }>;
//   actions: Array<string | { name: string, action: string }>;
//   children: urlOpts;
//   hostname: string;
//   version: number;
// }

export default {
  users: urls({
    name: "users",
    actions: [
      "top",
      "top-monthly",
      "top-supervisor",
      "top-vendor",
      "register",
      "change-password",
      "recover-password",
      "ranking"
    ],
    singleActions: ["goals", "supervisedgoals", "supervisedusers", "points", "avatar", "reset-password"]
  }),
  categories: urls({ name: "categories", singleActions: ["products"] }),
  products: urls({ name: "products" }),
  trainings: urls({
    name: "trainings",
    singleActions: ["answer"],
    children: { name: "questions" }
  }),
  trivias: urls({
    name: "trivias",
    singleActions: ["answer"],
    children: { name: "questions" }
  }),
  goals: urls({ name: "goals" }),
  avatars: urls({ name: "avatars" })
};



// WEBPACK FOOTER //
// ./src/reducers/urls.js